import { decryptPayload, } from '@standardnotes/encryption';
export class DecryptTypeAPayload {
    constructor(operatorManager) {
        this.operatorManager = operatorManager;
    }
    async executeOne(payload, key) {
        return decryptPayload(payload, key, this.operatorManager);
    }
    async executeMany(payloads, key) {
        return Promise.all(payloads.map((payload) => this.executeOne(payload, key)));
    }
}
